<script setup>
defineProps({
  isBlock: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <div
    :class="{
      [$style.wrapper]: true,
      [$style.block]: isBlock,
    }"
  >
    <div
      :class="{
        [$style.spinner]: true,
        [$style[color]]: !!color,
      }"
    />
  </div>
</template>

<style module lang="scss">
@use 'sass:math' as math;

$border: 2px;
$size: 20px;
$duration: .6s;

//Helper function
@function circlePosition($size, $border, $coordinate, $alt: false) {
  $center: ($size * 0.5) - $border - ($border * 0.5);
  $radius: ($size * 0.5) - $border + ($border * 0.5);
  $root: 0.70710678118; //sqrt(2)/2
  @if $coordinate == x or $alt == true {
    @return math.round($center + ($radius * $root));
  }
  @else {
    @return math.round($center - ($radius * $root));
  }
}

//Wrapper
.wrapper {
  display: inline-block;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  &.block {
    display: flex;
    justify-content: center;
    padding: 2rem;
  }
}

//Spinner
.spinner {
  width: $size;
  height: $size;
  border: $border solid transparent;
  border-color: var(--color-elements);
  border-right-color: transparent !important;
  border-radius: 50%;
  position: relative;
  animation: rotate $duration linear infinite;
  &:after {
    content: '';
    width: $border;
    height: $border;
    border-radius: 50%;
    position: absolute;
    top: circlePosition($size, $border, y);
    left: circlePosition($size, $border, x);
    background: var(--color-elements);
  }
  &:before {
    content: '';
    width: $border;
    height: $border;
    border-radius: 50%;
    position: absolute;
    top: circlePosition($size, $border, y, true);
    left: circlePosition($size, $border, x, true);
  }
  @keyframes rotate {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  &.white {
    border-color: var(--color-white);
    &:after {
      background: var(--color-white);
    }
  }
  &.primary {
    border-color: var(--color-primary);
    &:after {
      background: var(--color-primary);
    }
  }
  &.success {
    border-color: var(--color-status-success);
    &:after {
      background: var(--color-status-success);
    }
  }
  &.warning {
    border-color: var(--color-status-warning);
    &:after {
      background: var(--color-status-warning);
    }
  }
  &.danger {
    border-color: var(--color-status-danger);
    &:after {
      background: var(--color-status-danger);
    }
  }
}
</style>
